import { styled } from '@mui/system'
import { Input, InputLabel } from '@mui/material'

const Root = styled('div')({
  margin: 0,
  padding: 0,
})

const LabelStyle = styled(InputLabel)({
  color: '#e0e0e0',
  fontSize: '14px',
  fontWeight: '500',
  textTransform: 'capitalize',
  margin: '10px 0',
})

const InputField = styled(Input)({
  background: 'rgba(0, 0, 0, 0.3)',
  boxShadow: 'rgba(0, 0, 0, 0.3) 0px 2px 8px 0px',
  borderRadius: '8px',
  border: '1px solid #fff',
  padding: '5px 20px',
  textTransform: 'capitalize',
  width: '100%',
  color: '#ffffff',
  '&:hover': {
    border: '1px solid #666',
  },
  '&.Mui-focused': {
    border: '1px solid #90caf9',
  },
  '&::placeholder': {
    color: '#aaa',
    opacity: 1,
  },
  '& .MuiInput-input': {
    color: '#ffffff',
  },
  '&.Mui-error': {
    border: '1px solid #f44336',
  },
  '&.Mui-disabled': {
    background: 'rgba(0, 0, 0, 0.2)',
    border: '1px solid #333',
    color: '#777',
  },
})

const InputFieldStyle = { Root, LabelStyle, InputField }

export default InputFieldStyle
